import 'react-loading-skeleton/dist/skeleton.css'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const StyledLink = styled.span`
  text-align: center;
  font-size: 11pt;
  padding-left: 5px;
  a {
    text-decoration: none;
    margin-top: 1vw;
    color: ${props => props.theme.highlightColor};
  }
  a:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

type LinkProps = {
  label: string
  to: string
  disableRightClick?: boolean
}
export const CustomLink = ({ to, label, disableRightClick }: LinkProps) => {
  return (
    <StyledLink>
      <Link
        to={to}
        onContextMenu={e => disableRightClick && e.preventDefault()}
      >
        {label}
      </Link>
    </StyledLink>
  )
}
